import { render, staticRenderFns } from "./LoginPage2.vue?vue&type=template&id=fe63810c&scoped=true"
import script from "./LoginPage2.vue?vue&type=script&lang=ts"
export * from "./LoginPage2.vue?vue&type=script&lang=ts"
import style0 from "./LoginPage2.vue?vue&type=style&index=0&id=fe63810c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe63810c",
  null
  
)

export default component.exports